import React from "react";
import MasterData from "view/settings/masterdata/MasterData";

const NCRLogData = () => {
    
    const sections = [
        { label: "Status", value: "Status", items: [] },
        { label: "NCR/SO", value: "NCRSO", items: [] },
    ];

    return (
        <MasterData pageTitle="NCRLog" sections={sections} />
    );
};

export default NCRLogData;